import { FindServiceData } from "../../pages/ExtraPage/helpers";
import { isAgent, pushEvent } from "./pushEvent";

export function pushSelectExtraEvent({addedServices, category, currency}: {addedServices: FindServiceData[], category: string, currency: string}) {
  
  if(isAgent()) return;

  if(!Array.isArray(addedServices) || addedServices.length === 0) return;

  const items = addedServices.map(s => {
    const { service } = s;

    return {
      item_id: `${service.ssrCode}`,
      item_name: `${service.description}`,
      item_category: category,
      price: service.amount,
      quantity: 1
    }
  })

  const data = {
    currency,
    value: items.reduce((acc, item) => acc + item.price, 0),
    items
  }

  pushEvent({ event: 'add_to_cart', data})
}